export var EMFType;
(function (EMFType) {
    EMFType["PURCHASE"] = "purchase";
    EMFType["REDEEM"] = "redeem";
})(EMFType || (EMFType = {}));
